// app/javascript/helpers/index.js
import { Modal } from "bootstrap"

function formatFileSize(bytes) {
  if (!bytes && bytes !== 0) return "";
  const mb = bytes / (1024 * 1024);
  if (mb >= 1000) return `${(mb / 1024).toFixed(1)}GB`;
  if (mb >= 10) return `${Math.round(mb)}MB`;
  if (mb >= 1) return `${mb.toFixed(1)}MB`;
  const kb = bytes / 1024;
  return `${Math.round(kb)}KB`;
}

// Bootstrap doesn't auto-bump z-index on nested modals, so when another modal
// is already open (e.g. the "Write a new message" modal) lift this modal and
// its backdrop above whatever's underneath.
function showModalAboveOpenModals(modalEl) {
  const openModals = document.querySelectorAll(".modal.show").length;
  if (openModals > 0) {
    modalEl.style.zIndex = String(1080 + openModals * 10);
    modalEl.addEventListener("shown.bs.modal", () => {
      const backdrops = document.querySelectorAll(".modal-backdrop.show");
      const lastBackdrop = backdrops[backdrops.length - 1];
      if (lastBackdrop) lastBackdrop.style.zIndex = String(1075 + openModals * 10);
    }, { once: true });
  }
  Modal.getOrCreateInstance(modalEl).show();
}

function showFileTooLargeModal(filename, limitMb, fileBytes) {
  // Signed-in users who can still upgrade (Free/Starter) get the reusable
  // feature paywall instead of the generic "file too large" modal — same
  // entry point, richer pitch.
  const serverData = document.getElementById("server-data");
  const isSignedIn      = serverData && serverData.dataset.signedIn === "true";
  const hasProFeatures  = serverData && serverData.dataset.hasProFeatures === "true";
  if (isSignedIn && !hasProFeatures) {
    const paywallEl = document.getElementById("modal_feature_paywall_file_size");
    if (paywallEl) {
      showModalAboveOpenModals(paywallEl);
      return;
    }
  }

  const modalEl = document.getElementById("modal_file_too_large");
  if (!modalEl) {
    alert(`File ${filename || ''} exceeds the maximum size of ${limitMb}MB.`);
    return;
  }
  const filenameEl = modalEl.querySelector(".file-too-large__filename");
  const limitEl = modalEl.querySelector(".file-too-large__limit");
  const sizeEl = modalEl.querySelector(".file-too-large__size");
  if (filenameEl) filenameEl.textContent = filename || "This file";
  if (limitEl) limitEl.textContent = `${limitMb}MB`;
  if (sizeEl) sizeEl.textContent = formatFileSize(fileBytes);
  showModalAboveOpenModals(modalEl);
}

export function getMetaValue(name) {
  const element = findElement(document.head, `meta[name="${name}"]`);
  if (element) {
    return element.getAttribute("content");
  }
}

export function findElement(root, selector) {
  if (typeof root == "string") {
    selector = root;
    root = document;
  }
  return root.querySelector(selector);
}

export function toArray(value) {
  if (Array.isArray(value)) {
    return value;
  } else if (Array.from) {
    return Array.from(value);
  } else {
    return [].slice.call(value);
  }
}

export function removeElement(el) {
  if (el && el.parentNode) {
    el.parentNode.removeChild(el);
  }
}

export function insertAfter(el, referenceNode) {
  return referenceNode.parentNode.insertBefore(el, referenceNode.nextSibling);
}

export function checkAvailableForSubmitBtn($el) {
  let filled = true;
  const $form = $el.closest('form')

  // check input[type=text] in form
  $form.find("input[type=text]:not(.not-require)").each((index, element) => {
    if($(element).val() == ""){
      filled = false;
    };
  });
  // check select2 in form
  $form.find(".select2-selection__rendered").each((index, element) => {
    if ($(element).text().length == 0) {
      filled = false;
    }
  });

  const $submitBtn = $form.find(".btn-submit")

  if(filled === false){
    $submitBtn.removeClass('bg-light-primary')
    $submitBtn.addClass('bg-light-silver')
    $submitBtn.prop( "disabled", true );
  } else {
    $submitBtn.addClass('bg-light-primary')
    $submitBtn.removeClass('bg-light-silver')
    $submitBtn.prop( "disabled", false );
  }
}

export function checkFiles(files, options = {}) {
  const { imagesOnly = false, maxSizeMb = null } = options;
  let selectedFiles = []

  // Define allowed types based on context
  const allowedImageTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
  const allowedFileTypes = [
    'image/jpeg',
    'image/jpg',
    'image/png',
    'image/gif',
    'image/tiff',
    'application/dicom',
    'application/pdf',
    'model/stl',
    'application/zip',
    'application/x-zip-compressed'
  ];
  const allowedExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.tif', '.tiff', '.dcm', '.pdf', '.stl', '.zip'];

  const allowedTypes = imagesOnly ? allowedImageTypes : allowedFileTypes;

  Array.from(files).forEach((file, _index) => {
    // Check file type (by MIME type or extension fallback)
    const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
    const isAllowedType = allowedTypes.includes(file.type) || (!imagesOnly && allowedExtensions.includes(fileExtension));

    if (!isAllowedType) {
      const fileTypeMessage = imagesOnly
        ? 'Please select a valid image file (JPG, JPEG, PNG, or GIF)'
        : `File type ${fileExtension} is not allowed. Only JPG, JPEG, PNG, TIF, DCM, PDF, STL are accepted.`;
      alert(fileTypeMessage);
      return;
    }

    // Check file size — caller-provided limit (e.g. dropzone with VIP unlock)
    // wins over the layout-wide #server-data fallback.
    const fallbackLimit = parseInt($('#server-data').data('maximum-file-size-in-mb'));
    const maximumFileSizeInMb = Number.isFinite(parseInt(maxSizeMb)) ? parseInt(maxSizeMb) : fallbackLimit;
    if(file.size > 1024*1024*maximumFileSizeInMb){
      showFileTooLargeModal(file?.name, maximumFileSizeInMb, file?.size);
      return
    }

    selectedFiles.push(file)
  })

  const dataTransfer = new DataTransfer()
  selectedFiles.forEach((file) => dataTransfer.items.add(file))

  return [selectedFiles, dataTransfer.files]
}

export function loadingSpinner(value) {
  if (value) {
    $('.loading-container').removeClass('d-none')
  } else {
    $('.loading-container').addClass('d-none')
  }
}

export function checkNewReferralFormSubmitButton() {
  setTimeout(() => {
    const submitBtn = getReferralSubmitButton()
    const form = document.querySelector('#new_referral_form')
    const requiredFields = form.querySelectorAll(
      "input[type=text][required]:not([disabled]), input[type=hidden][required]:not([disabled]), textarea[required]:not([disabled])"
    );
    const isAnyUnfilledFields = [...requiredFields].some((field) => !field.value.trim());

    const requiedCheckFields = form.querySelectorAll('input[type=checkbox][required]:not([disabled])')
    const isAnyUncheckedFields = [...requiedCheckFields].some((field) => !field.checked);

    submitBtn.classList.toggle("btn-lock", isAnyUnfilledFields || isAnyUncheckedFields);
  }, 200);
}

export function addInputEventForRequiredFields() {
  const requiredFields = document.querySelector('#new_referral_form').querySelectorAll(
    "input[type=text][required]:not([disabled]), input[type=hidden][required]:not([disabled]), textarea[required]:not([disabled])"
  );

  requiredFields.forEach((field) => {
    field.addEventListener("input", checkNewReferralFormSubmitButton);
  });
}

export function generateRandomNumber() {
  // Generate a random number by the current timestamp
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');
  const milliseconds = String(now.getMilliseconds()).padStart(3, '0');

  return `${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
}
  
export function getReferralSubmitButton() {
  return document.querySelector('#newReferralFormSubmitButton')
}

export function showAlert(type, message) {
  const bootstrap_alert_class = {
    "notice": "alert-primary",
    "alert": "alert-danger",
  }
  const alert = document.createElement('div')
  alert.classList.add('alert', bootstrap_alert_class[type], 'alert-dismissible', 'fade', 'show')
  alert.setAttribute('role', 'alert')
  alert.innerHTML = ` ${message} 
  <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" data-flash-target="closeFlashBtn"></button>`
  document.querySelector('#flash').appendChild(alert)
  return alert;
}

export function getDateFromRelativeDate(relativeDate) {
  let dateToAdd = 1;
  switch(relativeDate) {
    case('1 Day'): dateToAdd = 1; break;
    case('1 Week'): dateToAdd = 7; break;
    case('2 Weeks'): dateToAdd = 14; break;
    case('1 Month'): dateToAdd = 30; break;
    default: dateToAdd = 365; break;
  }
  const date = new Date();
  date.setDate(date.getDate() + dateToAdd)
  let year = date.getFullYear();
  let month = (1 + date.getMonth()).toString().padStart(2, '0');
  let day = date.getDate().toString().padStart(2, '0');

  return year + '-' + month + '-' + day;
}

export function getModal(id) {
  const modal = document.getElementById(id);
  if (modal) { return Modal.getOrCreateInstance(document.getElementById(id)) }
  return modal
}

export function formHasChanges(form) {
  let formHasChanges = false;
  if (!form) return;

  for (let i = 0; i < form.elements.length; i++) {
    const el = form.elements[i]

    if (el.disabled) continue;

    // Track changes
    ['input', 'change'].forEach(eventType => {
      el.addEventListener(eventType, () => {
        switch (el.type) {
          case 'checkbox':
          case 'radio':
            if (el.checked !== el.defaultChecked) return true;
      
          case 'select-one':
          case 'select-multiple':
            const isDirty = Array.from(el.options).some(
              opt => opt.selected !== opt.defaultSelected
            );
            if (isDirty) return true;
      
          default:
            if (el.value !== el.defaultValue) return true;
        }
      });
    });
  };

  return formHasChanges
}